import { styled } from '@mui/material/styles';

export const BonusImage = styled('img')(() => ({

}));

export const BonusText = styled('div')(() => ({
    fontSize: '16px',
    left: '12%',
    position: 'absolute',
    top: '48%',
    width: '50%',

    '@media screen and (max-width: 600px)': {
        fontSize: 'calc(8px + 1vw)',
    },
}));

export const Container = styled('div')(() => ({
    alignItems: 'center',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    height: '298px',
    maxWidth: '100%',
    position: 'relative',
    width: '512px',

    '& img': {
        width: '100%',
    }
}));
